<template>
  <div class="boss-checkbox-button-group">
    <div class="boss-checkbox-button-group-title">
      表示対象者
    </div>
    <div>
      <label
        id="display-target-statuses"
        class="boss-checkbox-button"
      >
        <input
          v-model="selected"
          :value="statusIds"
          type="checkbox"
          class="boss-checkbox-button-input"
          data-test="statusIds"
        >
        <span
          class="boss-checkbox-button-content"
          data-test="statusNames"
        >選考中</span>
      </label>
    </div>
    <div
      v-for="(fixedStatus, i) in fixedStatuses"
      :key="i"
    >
      <label
        :id="'display-target-' + fixedStatus.id"
        class="boss-checkbox-button"
      >
        <input
          v-model="selected"
          :value="fixedStatus.id"
          type="checkbox"
          class="boss-checkbox-button-input"
          data-test="fixedStatusId"
        >
        <span
          class="boss-checkbox-button-content"
          data-test="fixedStatusName"
        >{{ fixedStatus.name }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    applicantObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: []
    }
  },
  computed: {
    statusIds () {
      return _.map([this.selectionValue, ...this.statuses], 'id')
    },
    selectedStatuses () {
      return _.flatten(this.selected)
    },
    ...mapGetters('settings', [
      'fixedStatuses',
      'statuses'
    ]),
    selectionValue () {
      return { id: null, name: '' }
    }
  },
  watch: {
    selectedStatuses (value) {
      this.filteredUpdate(this.applicantObjects, value)
      this.$emit('setDisplayTargets', value)
    },
    applicantObjects: {
      handler (value) {
        this.filteredUpdate(value, this.selectedStatuses, false)
      },
      deep: true
    },
    statuses: {
      handler (value) {
        value.length ? (!_.some(this.selected, val => {
          return _.isEqual(this.statusIds, val)
        })) && this.$set(this, 'selected', [this.statusIds])
          // 入社、NG、辞退のみが選考ステータスとして選ばられている場合にはデフォルト選考中idを追加
          : (!_.some(this.selected, val => {
              return _.isEqual([this.selectionValue.id], val)
            })) && this.$set(this, 'selected', [[this.selectionValue.id]])
      },
      immediate: true
    }
  },
  methods: {
    filteredUpdate (applicantObjects, selectedStatuses, checkedRest = true) {
      _.forEach(applicantObjects, o => {
        // 選択されている表示対象者だけ表示
        o.isDisplayTarget = _.includes(selectedStatuses, _.get(o, 'applicant.currentSelection.statusId'))
        // フィルターがかかったらチェック状況をリセット
        if (checkedRest) {
          o.isChecked = false
        }
      })
      this.$emit('filteredUpdate', applicantObjects)
    }
  }
}
</script>
